function normalizeSuppliers(supplierList) {
  let result = [];

  for (let i = 0; i < supplierList.length; i++) {
    let obj = supplierList[i];

    let node = {
      id: obj.supplierCountryId,
      label: obj.name,
    };

    // suppliers normalized for vuelist representation
    result.push(node);
  }

  return result;
}

function filterOut(suppliers, supplierFacets) {
  // should filter out only those suppliers that are among products
  // (this is done through facets)
  let filteredSuppliers = [];
  let realSupplierFacets = [];

  for (let i = 0; i < supplierFacets.length; i++) {
    let facets = supplierFacets[i].value.split(" ");
    realSupplierFacets = realSupplierFacets.concat(facets);
  }

  // remove duplicates:
  let uniqSupplierFacets = realSupplierFacets.reduce(function(a, b) {
    if (a.indexOf(b) < 0) a.push(b);
    return a;
  }, []);

  // remove empty string from uniq array
  uniqSupplierFacets.splice(uniqSupplierFacets.indexOf(""), 1);

  for (let i = 0; i < uniqSupplierFacets.length; i++) {
    for (let j = 0; j < suppliers.length; j++) {
      if (suppliers[j].id == uniqSupplierFacets[i]) {
        filteredSuppliers.push(suppliers[j]);
      }
    }
  }

  return filteredSuppliers;
}

export { normalizeSuppliers, filterOut };
